// extracted by mini-css-extract-plugin
export default {"styles":"Question1_styles__Mr9F-"};